<template>
  <div>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="6">
        <label><strong>Nome Completo</strong></label>
      </SGPColComponent>
      <SGPColComponent cols="6">
        <label><strong>E-mail</strong></label>
      </SGPColComponent>
    </SGPRowComponent>
    <SGPRowComponent no-gutters class="mb-3">
      <SGPColComponent cols="6">
        <label>{{ usuario.name }}</label>
      </SGPColComponent>
      <SGPColComponent cols="6">
        <label>{{ usuario.email }}</label>
      </SGPColComponent>
    </SGPRowComponent>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="6">
        <label><strong>Login</strong></label>
      </SGPColComponent>
      <SGPColComponent cols="6">
        <label><strong>Telefone</strong></label>

      </SGPColComponent>
    </SGPRowComponent>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="6">
        <label>{{ usuario.login }}</label>
      </SGPColComponent>
      <SGPColComponent cols="6">
        <label>{{ usuario.telefone_1 }}</label>
        <SGPFormBotaoComponent class="ml-6" fab rounded color="white" @click="editarTelefone()" small>
          <v-icon color="primary" large dark>mdi-pencil</v-icon>
        </SGPFormBotaoComponent>
      </SGPColComponent>
    </SGPRowComponent>

    <SGPModalComponent v-if="abrirModal" tamanho="sm" titulo="Editar Telefones" @sgpModalFechar="fecharModal"
      :mostrarFooter="false">
      <FormularioTelefonesUsuarioComponent :usuario="usuario" />
    </SGPModalComponent>

  </div>
</template>

<script>

import FormularioTelefonesUsuarioComponent from "./FormularioTelefonesUsuarioComponent.vue";

export default {
  components: { FormularioTelefonesUsuarioComponent },
  name: "CadastroUsuarioComponent",

  props: {
    usuario: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      abrirModal: false,
    }
  },

  methods: {
    fecharModal() {
      this.abrirModal = false;
    },

    editarTelefone() {
      this.abrirModal = true;
    },
  }
}
</script>